import React from 'react';
import { observer, inject } from 'mobx-react';
import { Trail } from 'react-spring';

import ListContainer from './ListContainer';
import Header from './Header';
import AddButton from './AddButton';
import Item from './Item';
import LoadMore from './LoadMore';
import DashboardLink from './DashboardLink';
import { navigate } from '@reach/router';
import { url } from 'js/services/Network';

export default inject('page')(
  observer(({ page, style, endpoint, addButton }) => {
    const trackClick = (e, item) => {
      e.preventDefault();
      analytics.track('CTA_SP_seller_checkout_start_item', {
        page: 'PartnerSellerPage',
        alias: item.alias,
        url: url(endpoint, item),
      });
      navigate(e.target.href, { replace: false });
      localStorage.setItem("STORE_ALIAS_SSS", page.micro_store)

      // console.log("seller country: ",page.seller_country)
    }


    return (<ListContainer style={style}>
      {/*<Header>*/}
      {/*  <DashboardLink />*/}
      {/*  {addButton !== false ? <AddButton /> : null}*/}
      {/*</Header>*/}

      <Trail native items={page.items} from={{ opacity: 0 }} to={{ opacity: 1 }} config={{ clamp: true }}>
        {item => animation => <Item item={item} style={animation}
                                    endpoint={endpoint ? endpoint : 'manage-item-page'}
                                    onClick={(e) => trackClick(e, item)}
        />}
      </Trail>

      {(page.hasMorePages || page.is_loading) && (
        <LoadMore isLoading={page.is_loading} onClick={page.loadMore}>
          {page.is_loading ? 'Loading' : 'Load more'}
        </LoadMore>
      )}
    </ListContainer>);
  }));
